import {
  DateRangePicker,
  last30Days,
  last90Days,
  lastYear,
  RadioFieldSet,
  yearToDate
} from 'components/core-v2'
import { SpeedDialRange } from 'components/core-v2/organisms/date-picker/speed-dial-section'

import { TODAY } from '../../../const'
import classes from './orders-filters.module.scss'

export const OrdersFilters = () => {
  const beginningSpeedDial: SpeedDialRange = {
    label: 'All trade history',
    value: [new Date('2019-01-01'), TODAY]
  }
  return (
    <div className={classes.root}>
      <DateRangePicker
        isPopover
        showClearDatesButton
        className="mb-4"
        defaultValue={last30Days.value}
        id="ordersDatePicker"
        speedDials={[beginningSpeedDial, last30Days, last90Days, lastYear, yearToDate]}
      />
      <RadioFieldSet
        legend=""
        name="orderTypeFilter"
        options={[
          { label: 'All', value: 'all' },
          { label: 'Buy', value: 'buy' },
          { label: 'Sell', value: 'sell' }
        ]}
      />
    </div>
  )
}
